import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

export const transferItem = createAsyncThunk(
    'transferController/transferItem',
     async ({ id, token,type,email }, { rejectWithValue }) => {

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/transfers/${id}`,
        {email},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params:{
            type
          }
        }
      );

      if (response.data.success) {
        
        return response.data.response;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data.message || "Error"
      );
    }
  }
);

const transferControllerSlice = createSlice({
    name: 'transferController',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(transferItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(transferItem.fulfilled, (state, action) => {
                state.loading = false;
                toast.success(action.payload)
               
            })
            .addCase(transferItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                toast.error(action.payload)
            });
    },
});

export default transferControllerSlice.reducer;